module.exports = __webpack_public_path__ + "img/car-battery-white.f50ca972.svg";